// Every English string the catering lane and its setting show, in one place
// so an Urdu table can be added later without touching the components.

export const CK = {
  chip: 'Catering',
  laneTitle: 'Catering',
  empty: 'No catering to cook right now.',
  emptyHelp: (days: number) =>
    days === 0 ? 'Locked plans show here on their day.' : `Locked plans show here from ${days === 1 ? 'the day' : `${days} days`} before.`,
  loadFailed: 'Could not load catering tickets.',
  tryAgain: 'Try again',
  badgeCatering: 'Catering',
  badgePlan: 'Kitchen plan',
  cookingNow: 'Cooking now',
  guests: (n: number) => `${n} guest${n === 1 ? '' : 's'}`,
  dishes: (ready: number, total: number) => `${ready}/${total} dishes ready`,
  changed: 'Quantity changed — check again',
  done: 'Done',
  marking: 'Marking done…',
  tapHelp: 'Tap each dish when it is ready, then Done',
  recall: 'Put back on the line',
  doneToday: 'Done on the board',
  doneNote: 'Marking a ticket done here does not finish the plan in Kitchen Production.',
  notReady: 'Mark every dish ready first.',
  lineFailed: 'Could not update the dish. Try again.',
  ticketChanged: 'This plan changed in Kitchen Production. The ticket has been refreshed.',
  bookingCancelled: 'BOOKING CANCELLED — check with the manager',
  bookingCancelledHelp: 'Do not cook this. The stock already sent can go back from the plan.',
  customerNote: 'Customer note',

  dueLate: (s: string) => `Overdue ${s}`,
  dueIn: (s: string) => `Due in ${s}`,
  dueAt: (s: string) => `Due ${s}`,
  today: 'Today',
  tomorrow: 'Tomorrow',
  yesterday: 'Yesterday',

  // Settings
  settingTitle: 'Catering on the Kitchen Display',
  settingHelp:
    'Locked production plans show on the Kitchen Display as catering tickets, with their dishes, guest count and a countdown to the event. Cooks tick dishes and mark the ticket done; that never changes the plan or stock in Kitchen Production. No prices or phone numbers are shown.',
  settingSwitch: 'Show catering on the Kitchen Display',
  settingDays: 'Show tickets from',
  settingDaysOption: (n: number) => (n === 0 ? 'the day of the event' : n === 1 ? '1 day before' : `${n} days before`),
  settingSaved: 'Saved',
  settingOnNote: 'Kitchen screens that are already open pick this up when they are reloaded.',
  settingKotOnly: 'Kitchen Mode is set to printed KOTs only, so there is no Kitchen Display to show these on.',
} as const
